/*
 * Public API Surface of catalog
 */
export * from './lib/extension/framework';
export * from './lib/extension/override-catalog';
// models
export * from './lib/models/column';
export * from './lib/models/column-composition-fns';
export { ColumnFactory } from './lib/models/column-factory';
export * from './lib/models/data';
export * from './lib/models/event-subscription';
export * from './lib/models/grouped-section';
export * from './lib/models/section';
export * from './lib/models/section-composition-fns';
export { SectionFactory } from './lib/models/section-factory';
export * from './lib/models/section-types.enum';
export * from './lib/models/validation-rules';
export * from './lib/models/control-types';
export { CatalogResponse } from './lib/models/catalog-response';
// pipes
export * from './lib/pipes/filter-hidden-columns.helper';
export * from './lib/pipes/filter-hidden-columns.pipe';
export { contextualizeSingleColumnField, contextualizeColumnsField } from './lib/pipes/contextualize-columns.helper';
export * from './lib/pipes/contextualize-column-form-control-options.helper';
export * from './lib/pipes/contextualize-column-form-control-options.pipe';
export { ContextualizeColumnPipe } from './lib/pipes/contextualize-column.pipe';
export { ContextualizeColumnsPipe } from './lib/pipes/contextualize-columns.pipe';
export * from './lib/pipes/data-column-formatter.pipe';
// services
export * from './lib/services/section-validator.service';
export * from './lib/services/subsection-maker.model';
export {
  makeGroupedSections,
  mergeByParentSectionId,
  SmallSection,
  SubsectionMakerService,
} from './lib/services/subsection-maker.service';
export {
  CatalogMethod,
  TokenReplacerFn,
  EntitySummarySection,
  ExtensionOptions,
  GetColumnOptions,
  CatalogsService,
} from './lib/services/catalogs.service';
export * from './lib/services/catalog-form-builder.service';
export * from './lib/services/user-catalogs.service';

// utils
export * from './lib/utils/compose';
export * from './lib/utils/is-detail-section';
export * from './lib/utils/is-widget-section';
export * from './lib/utils/merge-section-columns';
export * from './lib/utils/connect-catalog-lovs';
export * from './lib/utils/no-validate';
export * from './lib/utils/merge-utils';
export { deepCloneObject, deepCloneArray } from './lib/utils/clone-utils';
export { findFormControlOptionsByName } from './lib/utils/find-utils';
export * from './lib/utils/find-section-by-column-id';

export * from './lib/miq-catalog.module';
export * from './lib/dictionaries/columns-dictionary';
export * from './lib/dictionaries/sections-dictionary';
export * from './lib/validator/table-section-validations';
export * from './lib/validator/field-validations.factory';
